import MD5 from "crypto-js/md5";
import { IPayU } from '../types/payu';

/**
 * This method is used to change number format to money format
 * @param {String | Number} value 
 * @return {Number} moneyFormat
 */
export const moneyFormat = (value: string | number) => {
  let number = Number(value)
  try {
    if (isNaN(number)) number = 0
    const format = new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(number)
    return format
  } catch (error) {
    return 0
  }
}

/**
 * This method is used to change string format to money format
 * @param {String | Number} value 
 * @return {Number} numberFormat
*/
export const numberFormat = (value: string | number) => {
  let number = Number(value)
  try {
    if (isNaN(number)) number = 0
    const format = new Intl.NumberFormat('es-CO', {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(number)
    return format
  } catch (error) {
    return 0
  }
}

/**
 * This method is used to validate if email is valid.
 * @param {String} email
 * @return {Boolean}
*/
export const validateEmail = (email: string): boolean => {
  const expReg= /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
  const valid = expReg.test(email)
  if(valid === true)
  {
    return true;
  }
  else
  {
    return false;
  }
}

/**
 * This method is used to create sing to payment with format MD5
 * @param {Object} data payuData
 * @param {Number} price
 * @param {String} randomCode
 * @return {String} sign
*/
export const createSignature = (data: IPayU, price: number, randomCode: string): string =>
{
  let response = '';
  if(data)
  {
    const signature = `${data.apiKey}~${data.merchant_id}~${randomCode}~${price}~${data.currency}`
    response = MD5(signature).toString();
  }
  return response;
}